'use client';

import { useCategories } from '@/entities/category/api/query';
import FiltersButton from '@/features/filter-by-categories/ui/filter-button';
import TagSelect from '@/features/filter-by-categories/ui/tag-select';
import { Container } from '@/shared/ui';
import { Flex, Heading, HStack, Skeleton } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';


const CategoryFilters = () => {
  const t = useTranslations('common');
  const { data, isLoading } = useCategories({
    page: 1,
    limit: 20,
    is_active: 'true',
  });
  return (
    <Container direction="column" w="full">
      <Heading as="h2" fontWeight="bold" size="xl">
        {t('what_to_order')}
      </Heading>

      <Flex gap="2" py="2" suppressHydrationWarning>
        <TagSelect />

        {isLoading ? (
          <Flex flex="1" w="full" gap="2">
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <Skeleton key={item} h="85px" w="80px" rounded="xl" />
            ))}
          </Flex>
        ) : (
          <HStack
            flexWrap={{ base: 'nowrap' }}
            overflowX="auto"
            scrollbar="hidden"
            align="stretch"
            alignItems="flex-start"
          >
            {data?.shipper_categories.map((item) => (
              <FiltersButton key={item.id} category={item} />
            ))}
          </HStack>
        )}
      </Flex>
    </Container>
  );
};

export default CategoryFilters;
